import classNames from 'classnames';
import { PropsWithChildren, useMemo } from 'react';
import { FoggyBox } from '~/components/Box/Foggy/FoggyBox';
import { useBreakpoint } from '~/components/Breakpoint/Breakpoint.hook';
import { AspectRatio } from '~/components/Ratio/AspectRatio';
import styles from './ContentSelectFoggyBox.module.scss';

export type NftSelectBoxProps = PropsWithChildren<{
  contentLength: number;
  className?: string;
}>;
export const ContentSelectFoggyBox = ({
  contentLength,
  className,
  children,
}: NftSelectBoxProps) => {
  const breakpoint = useBreakpoint();

  const hasLessNft = useMemo(() => {
    switch (breakpoint) {
      case 'xsmall':
      case 'small':
        return contentLength <= 9;
      case 'medium':
        return contentLength <= 8;
      case 'large':
      case 'xlarge':
      case 'xxlarge':
        return contentLength <= 10;
    }
  }, [breakpoint, contentLength]);

  return (
    <AspectRatio
      className={classNames(
        styles.root,
        {
          [styles.small]: hasLessNft,
        },
        className
      )}>
      <FoggyBox className={styles.foggyBox}>{children}</FoggyBox>
    </AspectRatio>
  );
};
